import React, { FC } from 'react';
import { InputProps } from 'antd/lib/input/Input';
import { Input, PrefixIcon } from './Styles';

export const SearchInput: FC<InputProps> = (props) => {
  return <Input {...props} prefix={<PrefixIcon />} />;
};
